module.exports = __webpack_public_path__ + "img/3.09205b0e.png";